// Announcement 
$(document).ready(function () {
  $('.announcement_slide').slick({
      autoplay: true,  
      variableWidth: true,
      infinite: true,
      autoplaySpeed: 0,
      speed: 11000,
      arrows: false,
      swipe: false,
      slidesToShow: 1,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
  });
});



// Header Drawer
$('.header_wrapper header-drawer .header__icon').click(function(){
    $('html').addClass('header_drawer_open');
})
$('.header_wrapper .menu_drawer_overly, .menu_drawer_close_icon').click(function(){
    $('html').removeClass('header_drawer_open');
})

$(document).ready(function () {
  $('.menu-drawer__submenu ').slideUp();
  $('.menu_drawer__menu-item ').click(function(){
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  });
});


$(function(){
  // var lastScrollTop = 0, delta = 0;
  // $(window).scroll(function(event){
  //   var st = $(this).scrollTop();
  //   if(Math.abs(lastScrollTop - st) <= delta)
  //         return;
  //   if ((st > lastScrollTop) && (lastScrollTop>0)) {  // downscroll code
  //     $('body').removeClass('fixed_up_visible');
  //     $('body').addClass('fixed_down_visible');
  //   } else { // upscroll code
  //     $('body').addClass('fixed_up_visible');
  //     $('body').removeClass('fixed_down_visible');
  //   }
  //   lastScrollTop = st;
  // });

  var owl = $(".story-preview__container");
  owl.owlCarousel({
    items: 5,
    margin: 0,
    loop: false,
    nav: true,
    navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"></path></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"></path></svg>'
    ],
    dots: false,
    autoWidth:true,
  });
});


// Header Search
$(window).on("load", function () {
  var $footer = $('.shopify-section-group-footer-group').html();
  $('.search_footer_sec').wrapInner('<div class="inner_footer">'+ $footer +'</div>');

});


// Header mega menu & dropdown
$(document).ready(function () {
  var scrollTop = $("body");
  $(window).scroll(function () {
      var hieght = $('.header_announce_sec').innerHeight();
      var hieghts = $('.section-header').innerHeight();
  
    var topPos = $(this).scrollTop();
    if (topPos > 300) {
      $(scrollTop).addClass("scroll_top_header");
      $('.search_outer_sec').css('top', hieght + 'px');
      $('.search_outer_sec').css('height', 'calc(100vh - ' + hieghts + 'px)');
      $('.header_transparent_home .search_outer_sec').css('top', hieghts + 'px');
      $('.header_transparent_home  .search_outer_sec').css('height', 'calc(100vh - ' + hieghts + 'px)');
    } else {
      $(scrollTop).removeClass("scroll_top_header");
      $('.search_outer_sec').css('top', hieght + 'px');
      $('.search_outer_sec').css('height', 'calc(100vh - ' + hieght + 'px)');
      $('.header_transparent_home .search_outer_sec').css('top', hieghts + 'px');
      $('.header_transparent_home  .search_outer_sec').css('height', 'calc(100vh - ' + hieght + 'px)');
    }
  });

  $('.drop_menu__content > .mega-menu__list > li').hover(
    function () {
      // $('html').removeClass('serach_open');
      // $('.search_outer_sec').slideUp();
      // $('body').removeClass("menu_show_open");
      // $('body').toggleClass("menu_show_open");
      $('.drop_menu__content li').removeClass('avtive');
      $(this).toggleClass('avtive');
    },
    function () {
      // This is the second function for hover out event on 'li' itself
      // $('body').removeClass("menu_show_open");
      $('.drop_menu__content li').removeClass('avtive');
    }
  )

  $("body header.header nav > ul.list_menu > li .mega_head").hover(
    function () {
      $('html').removeClass('serach_open');
      $('.search_outer_sec').slideUp();
      $("body header.header nav > ul.list_menu > li").removeClass("menu_show");
      $('body').removeClass("menu_show_open");
      $('body').toggleClass("menu_show_open");
      $(this).toggleClass("menu_show");
    },
    function () {
      // This is the second function for hover out event on 'li' itself
      $('body').removeClass("menu_show_open");
      $(this).removeClass("menu_show");
    }
  );
  // When the mouse leaves the whole navigation (or body) element, remove the class
  $(document).on("mouseover", function (e) {
    if (
      !$(e.target).closest("body header.header nav > ul.list_menu > li").length
    ) {
      $("body header.header nav > ul.list_menu > li").removeClass("menu_show");
    }
    if (
      !$(e.target).closest(".drop_menu__content > .mega-menu__list > li").length
    ) {      
      $(".drop_menu__content > .mega-menu__list > li").removeClass("active");
    }
  });

  $('.mega_menu_overly').hover( function(e) {
      $('body').removeClass("menu_show_open");
      $("body header.header nav > ul.list_menu > li").removeClass("menu_show");
  })
  $(".summery_title ").next().slideUp();
  $(".summery_title ").click(function () {
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });
});



// Video Image Section
$(document).ready(function () {
  var $videoBlock = $('.video_block');
  $videoBlock.each(function () {
    var $this = $(this);
    var $iframe = $this.find('iframe');
    var $video = $this.find('.video_play'); // If targeting <video> tag
    var $poster = $this.find('.poster_img');
    var $playButton = $this.find('.play-button');
  
    // Initially hide iframe and video
    // $iframe.hide();
    // $video.hide();
  
    $playButton.on('click', function () {
      var iframeSrc = $iframe.attr('src');
      // Play HTML5 video if it exists
      if ($video.length) {
        $video.show().get(0).play();
      }
      // Show iframe if it's a YouTube/Vimeo video
      if ($iframe.length) {
        // Replace autoplay=0 with autoplay=1
        iframeSrc = iframeSrc.replace('autoplay=0', 'autoplay=1');
        $iframe.attr('src', iframeSrc).show();
      }
      $poster.hide();
      $playButton.hide();
    });
  });

  // Video Paly In Popup
  var $videopopup = $('.video_block_popup');
  $videopopup.each(function () {
    var $this = $(this);
    var $iframe = $this.find('iframe');
    var $video = $this.find('.video_play'); // <video> ટેગને લક્ષ્ય બનાવવું
    var $poster = $this.find('.poster_img');
    var $playButton = $this.find('.play-button');
  
    // Initially hide iframe and video
    // $iframe.hide();
    // $video.hide();
  
    $playButton.on('click', function () {
      $('.video_modal').css('display', 'flex');
      
      // Use clone() to avoid removing the iframe from the DOM
      var $iframeClone = $iframe.clone();
      var iframeSrc = $iframe.attr('src');
  
      // Replace autoplay=0 with autoplay=1
      iframeSrc = iframeSrc.replace('autoplay=0', 'autoplay=1');
  
      // Set the new src with autoplay
      $iframeClone.attr('src', iframeSrc).show();
  
      // Append the cloned iframe to the modal
      $('.video_modal .modal-content').html($iframeClone);
  
      // Play HTML5 video if it exists
      if ($video.length) {
        $video.show().get(0).play();
      }
  
      // Hide poster and play button
      // $poster.hide();
      $playButton.hide();
    });
    
    $('.video_modal span.close-modal').click(function(){
      $('.video_modal').hide();
      $playButton.show();
    });
  });
});

